module.exports = {
  getColor,
  getTextForTitle,
  getTextForDepartment,
  getCursorForNode,
  getKpiTargetName
}

function getKpiTargetName(node){
  return node.kpiName
}

function getTextForTitle(datum) {
  if (!datum.person || !datum.person.totalReports) {
    return ''
  }

  const { person: { totalReports } } = datum
  const pluralEnding = totalReports > 1 ? 's' : ''

  return `${totalReports} subordinate${pluralEnding}`
}

const departmentAbbrMap = {
  Marketing: 'mktg',
  Operations: 'ops',
  Growth: 'gwth',
  Branding: 'brand',
  Assurance: 'fin',
  Data: 'data',
  Design: 'design',
  Communications: 'comms',
  Product: 'prod',
  People: 'people',
  Sales: 'sales'
}

function getTextForDepartment(datum)  {
  if (!datum.departmentName) {
    return ''
  }
  return datum.departmentName.substring(0, 25).toUpperCase()  + (datum.departmentName.length > 25 ? '...' : '')
}

function getCursorForNode(datum) {
  return datum.children || datum._children || datum.hasChild
    ? 'pointer'
    : 'default'
}

function getColor(datum) {
  var departments = window.kpichart.getDepartmentList()
  if (datum.departmentName === null)
  {
    return ''
  } else {
    var currentDepartment = departments.find( ({ name }) => name === datum.departmentName)
    return currentDepartment.colors
  }
}
